import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import { CardContent } from 'components/Card'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
}
export default observer(function OpenItemsProgressionActions({ vm }: Props) {
  return (
    <>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.showJobStartedDialog()}
          dataTest="job-progression-set-job-started-button"
        >
          Documents Received
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})
